<template>
  <AppAlert variant="danger" hide-icon>
    <div class="disconnected-google-alert">
      <div class="disconnected-google-alert__header">
        <i class="disconnected-google-alert__icon fa-brands fa-google" />
        <span class="disconnected-google-alert__summary">
          <template v-if="isSingle">
            Your Google account <strong>{{ firstAccount.email }}</strong> was disconnected{{ disconnectedOn }}.
          </template>
          <template v-else>
            You have <strong>{{ data.total }}</strong> disconnected Google accounts.
          </template>
          <a :href="data.accountsUrl" class="disconnected-google-alert__link">Reconnect</a>
          to restore syncing and publishing.
        </span>
        <button
          v-if="!isSingle"
          type="button"
          class="disconnected-google-alert__toggle"
          :aria-expanded="expanded"
          aria-label="Show disconnected accounts"
          @click="expanded = !expanded">
          <i class="fa-solid" :class="expanded ? 'fa-chevron-up' : 'fa-chevron-down'" />
        </button>
      </div>

      <ul v-if="!isSingle && expanded" class="disconnected-google-alert__accounts">
        <li
          v-for="acc in data.accounts"
          :key="acc.email"
          class="contents">
          <span>&bull; {{ acc.email }}</span>
          <span class="disconnected-google-alert__date">{{ acc.disconnectedAt }}</span>
        </li>
        <li v-if="remaining > 0" class="disconnected-google-alert__more">
          <a :href="data.accountsUrl" class="disconnected-google-alert__link">…and {{ remaining }} more</a>
        </li>
      </ul>
    </div>
  </AppAlert>
</template>

<script setup>
import { ref, computed } from 'vue'
import { AppAlert } from '@/components/ui'

const props = defineProps({
  data: { type: Object, required: true }
})

const expanded = ref(false)
const isSingle = computed(() => props.data.total === 1)
const firstAccount = computed(() => props.data.accounts[0])
const disconnectedOn = computed(() => (firstAccount.value.disconnectedAt ? ` on ${firstAccount.value.disconnectedAt}` : ''))
const remaining = computed(() => props.data.total - props.data.accounts.length)
</script>
